"use client";

import Script from "next/script";
import { useSyncExternalStore } from "react";

import {
  getConsentServerSnapshot,
  getConsentSnapshot,
  subscribeToConsent,
} from "@/shared/lib/consent";

// Meta (Facebook) Pixel. Public ID — it ships in the page source by design, so
// it's not a secret. Overridable via NEXT_PUBLIC_META_PIXEL_ID; falls back to the
// production Hoku pixel. Empty string disables the pixel entirely (e.g. preview).
const PIXEL_ID =
  process.env.NEXT_PUBLIC_META_PIXEL_ID ?? "3829101827231768";

/**
 * The Pixel does not read Google's Consent Mode signals — Meta has its own
 * mechanism — so it is gated here instead. Without this the banner would look
 * like it governs tracking while the Pixel carried on regardless.
 *
 * Note the consequence: visitors who decline are no longer attributable in
 * Meta Ads. That is what consent means, but it will show up as a drop in
 * reported conversions rather than a drop in real ones.
 */
export default function MetaPixel() {
  const consent = useSyncExternalStore(
    subscribeToConsent,
    getConsentSnapshot,
    getConsentServerSnapshot,
  );

  if (!PIXEL_ID || consent !== "granted") return null;

  return (
    <>
      <Script id="meta-pixel" strategy="afterInteractive">
        {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`}
      </Script>
      <noscript>
        { }
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          alt=""
          src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
}
